import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { createDefaultHeaderData } from 'src/app/core/utilities/type-defaults.util';
import { HeaderData } from '../dynamic-header/category/header-data';
import { HeaderLayout } from '../dynamic-header/dynamic-header.component';
import { StaticSubMenuChildComponent } from './static-sub-menu-child/static-sub-menu-child.component';
import { StaticSubMenuComponent } from './static-sub-menu/static-sub-menu.component';

@Component({
  selector: 'static-menu-collapse',
  templateUrl: './static-menu-collapse.component.html',
  styleUrls: ['./static-menu-collapse.component.scss'],
  standalone: true,
  imports: [CommonModule, StaticSubMenuComponent, StaticSubMenuChildComponent]
})
export class StaticMenuCollapseComponent {
  private _selectedCategoryId = signal<string>('');
  private _selectedSubCategoryId = signal<string>('');

  readonly selectedCategoryId = this._selectedCategoryId.asReadonly();
  readonly selectedSubCategoryId = this._selectedSubCategoryId.asReadonly();
  readonly hasSelectedCategory = computed(() => !!this._selectedCategoryId());
  readonly hasSelectedSubCategory = computed(() => !!this._selectedSubCategoryId());

  readonly headerData = input<HeaderData>(createDefaultHeaderData());
  readonly headerLayout = input<string>('default');

  // Computed property to get menuItems from headerData
  readonly menuItems = computed(() => this.headerData().menuItems || []);

  // Computed property to check if layout is headerLayout12
  readonly isLayout12 = computed(() => this.headerLayout() === HeaderLayout.headerLayout12);

  HeaderLayout = HeaderLayout; // <-- exposed enum to template

  // Update output to use Angular 20 output() function
  hideMenu$ = output<boolean>();
  IMAGE_URLS = IMAGE_URLS;
  onHideMenu() {
    this.hideMenu$.emit(true);
  }

  categorySelected(id: string, e: Event) {
    // Toggle: if clicking the same category, close it; otherwise open the new one
    if (this._selectedCategoryId() === id) {
      this._selectedCategoryId.set('');
    } else {
      this._selectedCategoryId.set(id);
    }
    // Always clear sub-category selection when category changes
    this._selectedSubCategoryId.set('');
    e.stopPropagation();
  }

  subCategorySelected(id: string, e: Event) {
    // Toggle: if clicking the same sub-category, close it; otherwise open the new one
    if (this._selectedSubCategoryId() === id) {
      this._selectedSubCategoryId.set('');
    } else {
      this._selectedSubCategoryId.set(id);
    }
    e.stopPropagation();
  }

  hideMenu() {
    this.hideMenu$.emit(true);
  }
}

